import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const VARIANTS = [
  {
    group: "Hero",
    items: [
      { name: "Editorial Poster", path: "/preview/hero-editorial", desc: "Magazine-cover typography wrapping a single hero product." },
      { name: "Cold Terminal", path: "/preview/hero-terminal", desc: "Full-viewport boot sequence, monospace, red cursor, dot-grid." },
      { name: "Vault Door", path: "/preview/hero-vault", desc: "Centered composition with a monolithic opening slab reveal." },
    ],
  },
  {
    group: "Product page",
    items: [
      { name: "Bento Specs", path: "/preview/product-bento", desc: "Twelve-cell grid mixing image, price, spec tiles, features." },
      { name: "Long-Scroll Story", path: "/preview/product-story", desc: "Narrative long-form scroll: numbered sections + paragraphs." },
    ],
  },
  {
    group: "Shop / Catalogue",
    items: [
      { name: "Gallery Grid", path: "/preview/shop-gallery", desc: "Masonry-style cards with big imagery, hover reveal." },
      { name: "Menu Editorial", path: "/preview/shop-editorial", desc: "Numbered typographic rows, hover reveals a fixed side image." },
    ],
  },
];

export default function PreviewIndex() {
  return (
    <div className="pt-32 pb-24 px-6 md:px-10 min-h-[80svh]" data-testid="preview-index">
      <div className="overline mb-6">Ξ PREVIEW ROOM</div>
      <h1 className="font-display uppercase text-5xl md:text-8xl tracking-tight leading-[0.9]">
        Pick a<br />layout.
      </h1>
      <p className="mt-8 max-w-xl text-[#888]">
        Seven alternate directions for the hero, product page, and catalogue. Click any card
        to preview it live in place of the current design. Nothing changes globally until you tell me which to apply.
      </p>

      <div className="mt-20 space-y-16">
        {VARIANTS.map((g) => (
          <div key={g.group}>
            <div className="overline mb-6">{g.group}</div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {g.items.map((v, i) => (
                <Link
                  key={v.path}
                  to={v.path}
                  data-testid={`preview-${v.path.split("/").pop()}`}
                  className="card-tech p-8 group flex flex-col justify-between min-h-[220px] hover:bg-[#080808] transition-colors"
                >
                  <div>
                    <div className="overline text-[#444]">Variant {String(i + 1).padStart(2, "0")}</div>
                    <div className="font-display uppercase text-3xl tracking-tight mt-4">{v.name}</div>
                    <p className="mt-4 text-[#888] text-sm leading-relaxed">{v.desc}</p>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <span className="overline group-hover:text-[#EAEAEA] transition-colors">Open preview</span>
                    <ArrowUpRight size={16} className="text-[#666] group-hover:text-[#EAEAEA] transition-colors" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
